import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorWarehouseStockItemAvailability = () => {
  const stockAvailable = useCallback((body, callback) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/warehouse/stock-item/availability', payload, (response) => {
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { stockAvailable }
}

export default InteractorWarehouseStockItemAvailability
